import React from 'react';
import { useTranslation } from '~/dependencies';
import { NewSession } from '~/components/ActiveCall/types';
import { IconMute, IconMuteActiveRedline } from '~/assets/svgIcons';
import { ReactSVG } from './styles';

type MuteToggleButtonProps = {
  onClick: (session: NewSession) => void;
  session: NewSession;
};

/**
 * Component resposible to handler MUTE and UNMUTE display for active calls
 */
const MuteToggle = ({ onClick, session }: MuteToggleButtonProps) => {
  const { answered, mute: isMute } = session;

  const { t } = useTranslation();

  function clickHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    onClick(session);
  }

  return (
    <button
      type="button"
      title={
        isMute
          ? t('components.activeCalls.btn.unmute')
          : t('components.activeCalls.btn.mute')
      }
      disabled={!answered}
      onClick={clickHandler}>
      <ReactSVG
        src={isMute ? IconMuteActiveRedline : IconMute}
        selected={isMute}
      />
    </button>
  );
};

export default MuteToggle;
